var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHealth = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.9 74.1C205.8 66.7 195.2 63 184.7 63.3C171.6 63.3 158.3 68.7 148.6 78.7L141.7 85.8L134.8 78.7C125.1 68.7 111.9 63.3 98.8 63.3C88.2 63.3 77.8 66.8 69.2 74.1C47.5 92.9 46.4 126.5 66 146.8L133.7 216.8C135.9 219.1 138.8 220.3 141.7 220.3C144.6 220.3 147.5 219.1 149.8 216.8L217.4 146.8C237.1 126.5 236.1 92.9 213.9 74.1ZM205.4 135.1L141.8 200.9L78.2 135.1C66.9 123.4 64.2 100.4 80.4 86.8C94.4 74.7 113.6 80.7 122.9 90.3L141.9 109.9L160.9 90.3C170.1 80.7 189.4 74.6 203.4 86.8C219.2 100.6 216.9 123.2 205.4 135.1Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHealth, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/health.a2366927.svg";
export { ForwardRef as ReactComponent };